import TablePageApproveBase from './table_page_approve.vue';

export default TablePageApproveBase;
